// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-4c6f5a4a"};